'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import CustomImage from '@components/CustomImage';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import CommonContainer from '@components/CommonContainer';
import cn from './style.module.scss';
export default function WimbledonBridgeLifestyle(
  props: MarketingPageComponentProps
) {
  const lifeStyleData =
    props.locale.section?.wimbledonBridgeLifestyleContent || [];
  return (
    <Stack
      component="section"
      className={cn.wimbledonBridgeLifestyle}
      id="wimbledonBridgeLifestyleID"
    >
      <Box className={cn.wimbledonLifestyleInner}>
        <Box className={cn.wimbledonLifestyleStory}>
          <Mobile>
            <CustomImage
              src={
                props.images.wimbledon_bridge_life_style_banner?.mobileSrc || ''
              }
              alt={'BrookGreen Introduction Image'}
              width={768}
              height={768}
            />
          </Mobile>
          <Desktop>
            <CustomImage
              src={props.images.wimbledon_bridge_life_style_banner?.src || ''}
              alt={'BrookGreen Introduction Image'}
              width={768}
              height={768}
            />
          </Desktop>
        </Box>
        <Box
          className={cn.wimbledonLifestyleGraphics}
          sx={{
            backgroundImage: `url(${props.images.wimbledon_bridge_green_background?.src})`,
          }}
        />
        <Box className={cn.wimbledonLifestyleBody}>
          <CommonContainer
            maxWidth={{ xs: '100%', md: '1360px', lg: '1360px' }}
            flexGrow={1}
          >
            <Box className={cn.wimbledonLifestyleContent}>
              <Box className={cn.wimbledonLifestyleHeading}>
                <ParallaxText
                  variant="h2"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(
                    props.locale.section['wimbledonBridgeLifestyleHeading']
                  )}
                </ParallaxText>
              </Box>
              <Box className={cn.wimbledonLifestyleData}>
                <Box className={cn.wimbledonLifestyleData__element}>
                  {lifeStyleData.map((item: string, index: number) => (
                    <ParallaxText
                      key={index}
                      variant="p"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(item)}
                    </ParallaxText>
                  ))}
                </Box>
              </Box>
            </Box>
          </CommonContainer>
        </Box>
      </Box>
    </Stack>
  );
}
